export default __webpack_public_path__ + "static/media/environment2.147a1758.png";